import 'reflect-metadata';
import { Expose, Type } from 'class-transformer';
import { IsInt } from 'class-validator';
import { LengthType } from './LengthType';
import { Length } from './Length';
import LengthValue from './LengthValue';

export class AutoLength extends Length {
   
    @Expose()
    @Type(() => String)
    lengthType: LengthType = LengthType.Auto;

    @Expose()
    @IsInt()
    value: number = 1;

    toString(): string {
        return LengthType.Auto.toString();
    }
}

export const autoLengthDefault = new AutoLength();